import { Box, Tooltip as MantineTooltip, UnstyledButton } from '@mantine/core';
import { useRef, useState } from 'react';

import classes from './Tooltip.module.css';

interface TooltipProps {
  content: string;
}

let tooltipCounter = 0;

export const Tooltip: React.FC<TooltipProps> = ({ content }) => {
  const id = useRef(`tooltip-${++tooltipCounter}`);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box>
      <MantineTooltip label={content} withinPortal withArrow position="top" id={id.current}>
        <UnstyledButton
          type="button"
          data-tip
          data-for={id.current}
          data-event="click"
          data-event-off="blur"
          className={classes.tooltipButton}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
          onBlur={() => setIsOpen(false)}
        >
          ?
        </UnstyledButton>
      </MantineTooltip>
    </Box>
  );
};
